import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const updateCoverLetterSchema = z.object({
  content: z.string(),
});

export class UpdateCoverLetterDto extends createZodDto(updateCoverLetterSchema) {}
